import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

interface ProjectGalleryCardProps {
  title: string;
  imageSrc: string;
  slug: string;
  description?: string;
  location?: string;
  serviceType: 'sanitise' | 'pest-control';
}

const ProjectGalleryCard = ({ 
  title, 
  imageSrc, 
  slug, 
  description, 
  location,
  serviceType
}: ProjectGalleryCardProps) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    navigate(`/services/${serviceType}/${slug}`);
  };

  const handleImageError = () => {
    console.error(`Failed to load image for ${title}`);
    setImageError(true);
  };

  const bgColor = serviceType === 'sanitise' 
    ? 'bg-trhine-green-100' 
    : 'bg-trhine-brown-100';

  return (
    <div 
      className="bg-white rounded-lg shadow-lg hover:shadow-xl overflow-hidden cursor-pointer transition-all duration-300 relative group"
      onClick={handleClick}
      role="button"
      aria-label={`Lihat projek ${title}`}
    >
      <div className="relative h-48 w-full bg-gray-200">
        {!imageError && (
          <img 
            src={imageSrc}
            alt={title} 
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        )}
        {imageError && (
          <div className="absolute inset-0 flex items-center justify-center text-gray-500">
            Image not available
          </div>
        )}
        
        {/* "Lihat" button that appears on hover */}
        <div className={`absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center justify-center p-4`}>
          
          {location && (
            <p className="text-white text-center text-sm font-semibold mt-3">{location}</p>
          )}
          {description && (
            <p className="text-white text-center text-sm mt-2">{description}</p>
          )}
        </div>
      </div>
      <div className="p-4 flex justify-between items-center group-hover:bg-gray-50 transition-colors duration-300">
        <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
        <div className={`${bgColor} text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-x-2 group-hover:translate-x-0`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ProjectGalleryCard; 